import {
  ProvidersLibsContext,
  ProvidersLibsDispatchContext,
  useProvidersLibsReducer,
} from './providersLibsContext';

function ProvidersLibsContextProvider({ children }: React.PropsWithChildren) {
  const [providersLibs, dispatch] = useProvidersLibsReducer();

  return (
    <ProvidersLibsContext.Provider value={providersLibs}>
      <ProvidersLibsDispatchContext.Provider value={dispatch}>

        {children}

      </ProvidersLibsDispatchContext.Provider>
    </ProvidersLibsContext.Provider>
  );
}

export default ProvidersLibsContextProvider;
